<ng-container *ngIf="favorite_type == 'album'; else default">
    <ion-icon name="heart-outline" *ngIf="album && !isAlbumFavorite(album._id)" (click)="addAlbumFavorite(album)"></ion-icon>
    <ion-icon name="heart" class="text-red" *ngIf="album && isAlbumFavorite(album._id)" (click)="removeFavoriteAlbum(album)"></ion-icon>
</ng-container>

<ng-template #default>
    <ion-icon name="heart-outline" *ngIf="!isFavorite(trackId)" (click)="addToFavorite(album._id, trackId)"></ion-icon>
    <ion-icon name="heart" class="text-red" *ngIf="isFavorite(trackId)" (click)="removeFavorite(trackId)"></ion-icon>
</ng-template>
